enum AlertType {
  CHANGE = 'change',
  BOUNCE = 'bounce',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export default AlertType;
